var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeRectangularPrism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.16642e-17,0.517115,-0.245851,1.5054e-17,51.6574,68.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.901,106.4L34.901,121.324L15.98,101.425L34.901,81.527L34.901,96.451L148.511,96.451L148.511,81.527L167.431,101.425L148.511,121.324L148.511,106.4L34.901,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cube",
    transform: "matrix(1.95724,0,0,1.15844,-119.121,-30.764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.555,195.51L79.94,160.894L140.217,140.217L175.555,175.177L114.555,195.51Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.795007,-66.2836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.555,195.51L79.94,160.894L140.217,140.217L175.555,175.177L114.555,195.51Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-34.6156,-34.6156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,25.6615,-55.2928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,60.9994,-20.3331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.49px"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.766996,-0.143212,0.0451249,0.241674,93.0428,183.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.52,106.4L28.52,121.324L15.98,101.425L28.52,81.527L28.52,96.451L154.892,96.451L154.892,81.527L167.431,101.425L154.892,121.324L154.892,106.4L28.52,106.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.426364,-0.268452,0.130993,-0.208047,88.6563,232.183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.399,106.4L35.399,121.324L15.98,101.425L35.399,81.527L35.399,96.451L148.012,96.451L148.012,81.527L167.431,101.425L148.012,121.324L148.012,106.4L35.399,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-64.7692,85.6588)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "h")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,91.2157,176.099)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "w")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-29.4799,168.214)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "l")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,65.9488,131.04)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeRectangularPrism);
export default __webpack_public_path__ + "static/media/calc-figure-volume-rectangularPrism.85d4cbd374eea9b95f6524928be91295.svg";
export { ForwardRef as ReactComponent };